import React from 'react'
import CheckActiveOutlineSVG from "../../../assets/icons/check-active.svg";

export const CheckActiveOutline: React.FC = () => {
  return (
    <img src={CheckActiveOutlineSVG} alt="" className="w-[25px] h-[25px]" />
  )
}
